import React, { useContext, useMemo, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useParams } from 'react-router-dom';

import { CompetencyType } from 'hooks/useGetAssessmentSteps';
import useGetCompetencyDetails from 'hooks/useGetCompetencyDetails';
import CompetencyQuestions from 'pages/Competency/CompetencyQuestions';
import CompetencyRubrics from 'pages/Competency/CompetencyRubrics';
import CompetencySettingsForm from 'pages/Competency/CompetencySettingsForm';
import CompetencyTitle from 'pages/Competency/CompetencyTitle';
import { AssessmentDetailsContext } from 'providers/AssessmentDetailsProvider';

const Competency = () => {
  const { interviewUid = '', competencyUid = '' } = useParams();
  const { data, isLoading } = useGetCompetencyDetails(
    interviewUid,
    competencyUid
  );
  const [isQuestion, setIsQuestion] = useState(false);
  const { isPractice } = useContext(AssessmentDetailsContext);
  const rubrics = data?.rubrics ?? [];
  const rubricsPointScale =
    rubrics.map((rubric) => rubric.rating_scale_value) ?? [];
  const pointScale = rubricsPointScale.length;

  useMemo(() => {
    if (data?.type) {
      setIsQuestion(
        [
          CompetencyType.QUESTIONS,
          CompetencyType.VIDEO,
          CompetencyType.WRITTEN,
        ].includes(data?.type as CompetencyType)
      );
    }
  }, [data]);

  return (
    <div className="round m-8 flex flex-col text-kira-slate-900">
      {isLoading ? (
        <Skeleton height={80} className="mb-4" />
      ) : (
        <CompetencyTitle
          competencyName={data?.name ?? ''}
          questionsCount={data?.number_of_questions ?? 0}
          pointScale={pointScale}
          isQuestion={isQuestion}
        />
      )}
      {!isPractice && (
        <>
          <CompetencySettingsForm
            competencyType={data?.type ?? ''}
            descriptionDefaultValue={data?.description ?? ''}
            weightDefaultValue={data?.weight ?? 0}
            isLoading={isLoading}
          />
          <CompetencyRubrics
            rubrics={rubrics}
            interviewUid={interviewUid}
            competencyUid={competencyUid}
            isLoading={isLoading}
          />
        </>
      )}
      {isQuestion && (
        <CompetencyQuestions
          questions={data?.questions ?? []}
          isLoading={isLoading}
        />
      )}
    </div>
  );
};

export default Competency;
